// extracted by mini-css-extract-plugin
export default {"form":"Saver_form__m5k7X","extension":"Saver_extension__UjxuC","invalid":"Saver_invalid__Dqsju","error":"Saver_error__cPTfQ","saveas":"Saver_saveas__c8FxT"};